import React, { useEffect, useState } from "react";
import { AiOutlineHome } from "react-icons/ai";
import { CiSettings, CiSquareMore } from "react-icons/ci";
import { NavLink, useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth";
import { useDispatch } from "react-redux";
import { BiUpload } from "react-icons/bi";
import { AiOutlineMenu } from "react-icons/ai";
import { RxCross2 } from "react-icons/rx";
import { BiChevronDown, BiPlus } from "react-icons/bi";
import { functions } from "../../config/firebase-config";
import { IoClose } from "react-icons/io5";
import OutsideClickHandler from "../../utils/OutsideClickHandler";
import { AiOutlineLink } from "react-icons/ai";
import { toast } from "react-toastify";
import { httpsCallable } from "firebase/functions";
import { useSelector } from "react-redux";
import moment from "moment";
import { MdLabel } from "react-icons/md";
import { FaUsers } from "react-icons/fa";
import { BsCardChecklist, BsGraphUp } from "react-icons/bs";
import ExceededPopup from "../Popups/ExceededPopup";
import { BiCrown } from "react-icons/bi";
import { getCurrentUser } from "../../services/UserService"
import { getStatsMeetings } from "../../services/StatsMeetingService"
import { createUserBotMeetings, fetchBotMeetings } from "../../services/UserBotMeetingService"
import { findIfPaidUserForCrown } from "../../services/CommonService"


const MobSidebar = () => {
  const auth = getAuth();
  const [meetCount, setMeetCount] = useState(0);
  const [menu, setMenu] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [meetLinkModal, setMeetLinkModal] = useState(false);
  const [meetData, setMeetData] = useState({ meetLink: "", meetName: "" });
  const addBot = httpsCallable(functions, "addBot");
  const [profileDropdown, setProfileDropdown] = useState(false);
  const { userData } = useSelector((state) => state.authReducer);
  const { uid } = useSelector((state) => state.authReducer);
  const getMeetCount = async () => {
    getStatsMeetings(
        (response) => {
          const res = response.data;
          const count = res?.processingCount;
          setMeetCount(count);
        }
    )
  };
  const [totalMinutes, setTotalMinutes] = useState(0);
  const [exceededModal, setExceededModal] = useState(false);
  const [isExceededHours, setIsExceededHours] = useState(false);
  const [showCrown, setShowCrown] = useState(false);

  const fetchData = async () => {
    if (userData) {
      if (
        userData?.meetTimeChecker &&
        userData?.meetTimeChecker.hours !== undefined
      ) {
        const totalTime =
          userData?.meetTimeChecker.hours * 60 +
          userData?.meetTimeChecker.minutes +
          userData?.meetTimeChecker.seconds / 60;
        setTotalMinutes(totalTime);
        console.log("TotalMinutes (after state update): ", totalTime);
      }

      const subscriptionData = userData?.subscription || {};
      const subscriptionName = Object.keys(subscriptionData)[0];
      const currentDate = Math.floor(new Date().getTime() / 1000);
      const endDate = subscriptionData?.[subscriptionName]?.periodEnd;
      if (
        subscriptionName === "free" ||
        ((subscriptionName === "productivity pro" || subscriptionName === "business") && endDate >= currentDate)
      ) {
        const limitFromCollection = subscriptionData?.[subscriptionName]?.timeLimit;
        if (limitFromCollection === -1) {
          setExceededModal(false);
        } else if (limitFromCollection < totalMinutes) {
          setExceededModal(true);
        }
      } else {
        setExceededModal(true);
      } 
    }
  };

  useEffect(() => {
    fetchData(); // Call fetchData function inside useEffect
  }, [totalMinutes]);

  useEffect(() => {
    getMeetCount();
  }, []);

  useEffect(() => {
    findIfPaidUserForCrown({ setShowCrown, userData });
  }, []);

  const style1 = "text-3xl";
  const style2 =
    "flex gap-[20px] my-[20px] mx-auto justify-start items-center text-black";

  return (
    <>
      <div onClick={() => setMenu(true)}>
        <AiOutlineMenu className="w-[30px] h-[30px]" />
      </div>
      {menu && (
        <>
          <div className="w-[100vw] h-[100vh] absolute left-0 top-0 bg-white z-10 sidebar">
            <div className="w-[60%] h-full mx-auto mt-[40px]">
              <div
                onClick={() => {
                  setProfileDropdown(true);
                }}
                className=" mb-[30px] w-full flex flex-col justify-center relative"
              >
                <div
                  className={`flex items-center my-[10px] gap-[10px] justify-center flex-wrap`}
                >
                  <img
                    src={
                      userData?.profile ||
                      auth?.currentUser?.photoURL ||
                      "https://cdn-icons-png.flaticon.com/256/149/149071.png"
                    }
                    className="w-[100px] h-[100px] rounded-full shadow-md"
                    alt=""
                  />
                  <div className="text-black min-w-fit text-xl font-medium flex items-center">
                    <div>
                      {userData?.name
                        ? userData.name
                        : auth?.currentUser?.displayName}
                    </div>
                    {showCrown && (
                      <div className="bg-white p-[5px] rounded-full ml-2">
                        <BiCrown className="text-yellow-500 text-2xl" />
                      </div>
                    )}
                  </div>
                </div>
                {profileDropdown && (
                  <div className="absolute bg-white top-[110%] w-full drop-shadow-lg rounded-md modalAnimation text-sm">
                    <OutsideClickHandler
                      onClick={() => {
                        setProfileDropdown(false);
                      }}
                    >
                      <div className="flex flex-col bg-white w-full">
                        <div
                          onClick={() => {
                            navigate("/settings");
                            setMenu(false);
                          }}
                          className="border-b px-[10px] py-[5px] cursor-pointer text-[black]"
                        >
                          Account
                        </div>
                        <div
                          onClick={() => {
                            import("../../redux/actions/authActions").then(
                              (actions) => dispatch(actions.logout())
                            );
                            localStorage.clear();
                            setMenu(false);
                            navigate("/login");
                          }}
                          className="border-b px-[10px] py-[5px] cursor-pointer text-[black]"
                        >
                          Logout
                        </div>
                      </div>
                    </OutsideClickHandler>
                  </div>
                )}
              </div>
              <NavLink to="/" className="" onClick={() => setMenu(false)}>
                <div
                  className={`${style2} ${
                    window.location.pathname === "/" && "text-blue-900"
                  }`}
                >
                  <AiOutlineHome className={style1} />
                  <span>Home</span>
                </div>
              </NavLink>
              <div onClick={() => setMenu(false)}>
                <RxCross2 className="text-[black] absolute right-[20px] top-[15px] w-[30px] h-[30px]" />
              </div>
              <NavLink to="/uploads" onClick={() => setMenu(false)}>
                <div
                  className={`${style2} ${
                    window.location.pathname === "/uploads" && "text-blue-900"
                  }`}
                >
                  <BiUpload className={style1} />
                  <span>Uploads</span>
                </div>
              </NavLink>
              <NavLink to="/meetings" onClick={() => setMenu(false)}>
                <div
                  className={`${style2} ${
                    window.location.pathname === "/meetings" && "text-blue-900"
                  }`}
                >
                  <FaUsers className={style1} />
                  <span>Meetings</span>
                </div>
              </NavLink>
              <NavLink to="/task" onClick={() => setMenu(false)}>
                <div
                  className={`${style2} ${
                    window.location.pathname === "/task" && "text-blue-900"
                  }`}
                >
                  <BsCardChecklist className={style1} />
                  <span>Tasks</span>
                </div>
              </NavLink>
              <NavLink to="/settings" onClick={() => setMenu(false)}>
                <div
                  className={`${style2} ${
                    window.location.pathname === "/settings" && "text-blue-900"
                  }`}
                >
                  <CiSettings className={style1} /> <span>Settings</span>
                </div>
              </NavLink>
              {
                userData?.organisation_info?.organisation_role == "organisation_admin" && (
                  <NavLink to="/reports" onClick={() => setMenu(false)}>
                    <div
                      className={`${style2} ${
                        window.location.pathname === "/reports" && "text-blue-900"
                      }`}
                    >
                      <BsGraphUp className={style1} /> <span>Reports</span>
                    </div>
                  </NavLink>   
                )
              }
              <div className="flex justify-center gap-[2px] relative mx-auto my-[10px]">
                {dropdownOpen && (
                  <div className="absolute bg-white top-[110%] w-full drop-shadow-lg rounded-md modalAnimation text-sm">
                    <OutsideClickHandler
                      onClick={() => {
                        setDropdownOpen(false);
                      }}
                    >
                      <div className="flex flex-col">
                        {/* <div
                          onClick={() => {
                            navigate("/upload");
                            setMenu(false);
                          }}
                          className="border-b px-[10px] py-[5px] cursor-pointer text-[black]"
                        >
                          Create Notes
                        </div> */}
                        {/* <div
                          onClick={() => {
                            navigate(`/upload`);
                            setMenu(false);
                          }}
                          className="border-b px-[10px] py-[5px] cursor-pointer text-[black]"
                        >
                          Upload Audio
                        </div> */}
                        {/* <div
                          onClick={() => {
                            navigate("/upload?type=1");
                            setMenu(false);
                          }}
                          className="border-b px-[10px] py-[5px] cursor-pointer text-[black]"
                        >
                          Upload Transcription
                        </div> */}
                        <div
                          onClick={() => {
                            if (!isExceededHours) {
                              setMeetLinkModal(true);
                              setMenu(false);
                            } else {
                              setExceededModal(true);
                            }
                          }}
                          className="border-b px-[10px] py-[5px] cursor-pointer text-[black]"
                        >
                          Join with Meeting Link
                        </div>
                      </div>
                    </OutsideClickHandler>
                  </div>
                )}
                <div
                  onClick={() => {
                    if (!isExceededHours) {
                      setMeetLinkModal(true);
                    } else {
                      setExceededModal(true);
                    }
                  }}
                  className="lg:text-[18x] text-center py-[10px] flex items-center justify-center gap-[5px] md:text-[16px] text-[12px] bg-[#07457F] text-white w-full rounded-l-[10px] lg:px-[10px] px-[5px] cursor-pointer"
                >
                  <BiPlus className="text-xl" />
                  Join Meeting
                </div>
                <div
                  onClick={() => {
                    setDropdownOpen(true);
                  }}
                  className="lg:text-[18x] text-[16px] bg-[#07457F] text-[white] rounded-r-[10px] px-[5px] flex items-center justify-center cursor-pointer"
                >
                  <BiChevronDown className="text-xl" />
                </div>
              </div>
              {exceededModal && (
                <ExceededPopup
                  onClose={() => {
                    setExceededModal(false);
                  }}
                />
              )}
              {meetLinkModal && (
                <div className="h-[100vh] w-[100vw] bg-[rgba(0,0,0,0.5)] fixed top-0 left-0 flex flex-col z-40 justify-center items-center">
                  <div className="w-fit flex flex-col items-end modalAnimation max-w-[85%]">
                    <div
                      onClick={() => {
                        setMeetLinkModal(false);
                      }}
                      className="bg-white cursor-pointer z-30 mb-[10px] w-fit rounded-full p-[2px]"
                    >
                      <IoClose />
                    </div>
                    <div
                      className={`rounded-md bg-white border-box relative p-[15px] max-h-[85vh] text-sm sm:text-base w-[300px] overflow-auto overflow-x-hidden`}
                    >
                      <div className="text-lg">Enter Meet Details</div>
                      <div className="my-[10px] rounded-md border p-[5px] flex items-center gap-[10px]">
                        <AiOutlineLink />
                        <input
                          value={meetData.meetLink}
                          onChange={(e) => {
                            setMeetData((data) => {
                              return { ...data, meetLink: e.target.value };
                            });
                          }}
                          type="text"
                          className="outline-none flex-grow"
                          placeholder="Meet link"
                        />
                      </div>
                      <div className="my-[10px] rounded-md border p-[5px] flex items-center gap-[10px]">
                        <MdLabel />
                        <input
                          value={meetData.meetName}
                          onChange={(e) => {
                            setMeetData((data) => {
                              return { ...data, meetName: e.target.value };
                            });
                          }}
                          type="text"
                          className="outline-none flex-grow"
                          placeholder="Meet Name (Optional)"
                        />
                      </div>
                      <button
                        onClick={() => {
                          if (meetData.meetLink) {
                            addBot({
                              meetLink: meetData.meetLink,
                              user_id: uid,
                            }).then((res) => {
                              let user = getCurrentUser();
                              createUserBotMeetings(user.uid,
                                {
                                  botId: res.data.bot_id,
                                  createdAt: new Date(),
                                  meetLink: meetData.meetLink,
                                  name: meetData.meetName,
                                  hashTag: "#AdhocMeets",
                                },
                                (response) => {
                                  fetchBotMeetings(dispatch);
                                  navigate("/meetings?pastAdhoc");
                                }
                              )
                            });
                            setMeetLinkModal(false);
                            setMeetData({ meetLink: "", meetName: "" });
                          } else {
                            toast.error("Enter meet link");
                          }
                        }}
                        className="py-[5px] w-fit px-[20px] mt-[10px] float-right bg-[#07457f] text-white rounded-md flex items-center justify-center"
                      >
                        Proceed
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="p-[10px] w-full bg-[#07457f] text-white font-medium text-center absolute bottom-0">
              {meetCount || 0}+ meetings summarised worldwide&nbsp;!
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default MobSidebar;
